import { createFileRoute } from "@tanstack/react-router";
import { MobileEditorWithSidebar } from "@papier/mobile-editor/src/components/MobileEditorWithSidebar";

export const Route = createFileRoute("/mobile-push")({
  component: RouteComponent,
});

function RouteComponent() {
  console.log("[Mobile Route] RouteComponent rendered");

  const initialContent = "Hi {{author.firstName}}, this is your notification preview!";

  return (
    <div className="relative" style={{ height: "100vh" }}>
      <MobileEditorWithSidebar mode="push" initialContent={initialContent} />
    </div>
  );
}
